// These are statuses for in-flight requests. If a request has no status
// associated with it, then it will have the `NULL` status.
export default {
  NULL: 'NULL',
  PENDING: 'PENDING',
  FAILED: 'FAILED',
  SUCCEEDED: 'SUCCEEDED'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-resource/es/utils/request-statuses.js
// module id = 70
// module chunks = 2